var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_1121)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_801_1121",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3999 0H0.399902V36H36.3999V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_801_1121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6746 10.275L27.8346 12.435L20.5146 19.755L15.5796 14.82C14.9946 14.235 14.0496 14.235 13.4646 14.82L4.46463 23.835C3.87963 24.42 3.87963 25.365 4.46463 25.95C5.04963 26.535 5.99463 26.535 6.57963 25.95L14.5146 18L19.4496 22.935C20.0346 23.52 20.9796 23.52 21.5646 22.935L29.9496 14.565L32.1096 16.725C32.5746 17.19 33.3846 16.86 33.3846 16.2V9.75C33.3996 9.33 33.0696 9 32.6496 9H26.2146C25.5396 9 25.2096 9.81 25.6746 10.275Z",
    fill: "#00067E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_1121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.f84d3cc364de69165a340094c5b002d6.svg";
export { ForwardRef as ReactComponent };